import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-page-not-found-link',
    templateUrl: './page-not-found-link.component.html',
    styleUrl: './page-not-found-link.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageNotFoundLinkComponent implements OnInit {

  public componentData$: Observable<CmsLinkComponent>;

  constructor(public component: CmsComponentData<CmsLinkComponent>) { }

  ngOnInit(): void {
    this.componentData$ = this.component.data$;
  }
}